//import React, {Component} from 'react';
import React from 'react';
import PropTypes from 'prop-types';
//import { withStyles } from '@material-ui/core/styles';
import {withStyles} from "@material-ui/core";
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Icon from '@material-ui/core/Icon';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
//import EmojiTransportationIcon from '@material-ui/icons/EmojiTransportation';
import SecurityIcon from '@material-ui/icons/Security';
//import Icon from '@material-ui/core/Icon';
//import Button from '@material-ui/core/Button';
import Fab from '@material-ui/core/Fab';
//import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import Tooltip from '@material-ui/core/Tooltip';
import Popover from '@material-ui/core/Popover';
import NavigationIcon from '@material-ui/icons/Navigation';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import Grid from "@material-ui/core/Grid";
import GridList from '@material-ui/core/GridList';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';


 /* const styles = {


};*/

const styles = theme => ({
    margin: {
        margin: theme.spacing.unit * 2,
    },
    extendedIcon: {
        marginRight: theme.spacing.unit * 8,
    },
    card: {
        maxWidth: '100%',
        backgroundColor:'#e9eef2',
        borderWidth:2,
        borderColor:'black',
        marginBottom:'10px'
    },
    cardpink: {
        maxWidth: '100%',
        backgroundColor:'#f7c979',
        borderWidth:2,
        borderColor:'black',
        marginBottom:'10px'
    },

    textLeftMargin: {

        marginLeft:'20px'
    },
});


//'url(' + require('../../images/IMG_1.JPG')
class CardFullTowJobInformation extends React.Component {

            constructor(props) {
                super(props);
                this.state = {
                    age: '',
                    name: 'Farshid',
                    testnumber: '1232322',
                    labelWidth: 0,
                    open:false,
                    editMode: true,
                };
                //const unsubscribe = store.subscribe( () => {/*console.log(store.getState())*/});
                this.deleteImageClick = this.deleteImageClick.bind(this);
                this.editImageClick = this.editImageClick.bind(this);
                this.handleClickOpen = this.handleClickOpen.bind(this);
                this.handleClose = this.handleClose.bind(this);
                this.PaperComponent = this.PaperComponent.bind(this);
                this.handleDelete = this.handleDelete.bind(this);

            }


    deleteImageClick(argData){

        //alert('delete was 1 called');
        // this.props.onDelete(argData.id);
        this.setState({ open: true });


    }

    /*
    private String policedepartmentname;
	private String policechiefname;
	private String policeemail;
	private String policephone;
	private String policefax;
	private String policeaddress1;
	private String policeaddress2;
	private String policecity;
	private String policestate;
	private String policecountry;
	private String policezipcode;
	private String policeid;

	private String storagelotid;
	private String storagelotname;
	private String storagelotphone;
	private String storagelotfax;
	private String storagelotaddress1;
	private String storagelotaddress2;
	private String storagelotcity;
	private String storagelotstate;
	private String storagelotcountry;
	private String storagelotzipcode;


	private String locationid;
	private String locationname;
	private String locationphone;
	private String locationfax;
	private String locationaddress1;
	private String locationaddress2;
	private String locationcity;
	private String locationstate;
	private String locationcountry;
	private String locationzipcode;
	private String locationtype;
	private String locationauthorizedpeople;

	private String vehicleid;
	private String vehiclemodel;
	private String vehiclemake;
	private String vehicleyear;
	private String vehiclecolor;
	private String vehicleplatenumber;
	private String vehiclestate;
	private String vehiclevin ;
	private String vehiclecountry;
	private String vehiclebody;
	private String vehicletype;

	private String reasoncause;
	private String reasonnote;
	private String towcompanyid;
	private Date createdDate;
	private Date modifiedDate;
	private Date endDate;
	private String userid;


     */

    editImageClick(argData){
        //alert('edit was  1 called');
        /*const { data} = this.props;
        data.forEach((item)=>{item.editMode = false});
        if(argData.editMode){
            if(argData.editMode == true) {

                argData.editMode = false;
            }else{
                argData.editMode = true;
            }
        }else{
            argData.editMode = true;
        }
        */
        this.setState({editMode:true});

        this.props.onEdit(argData);
    }

    handleClickOpen(){
        this.setState({ open: true });
    };

    handleClose(){
        this.setState({ open: false });
    };

    handleDelete(){
        this.props.onDelete(this.props.info.id);
        this.setState({ open: false });
    };

    PaperComponent(props) {
        return (
            <Draggable cancel={'[class*="MuiDialogContent-root"]'}>
            <Paper {...props} />
        </Draggable>
    );
    }


            render() {
            const {classes} = this.props;
            let framelen = 2;
               // const classes2 = useStyles();
                let tempImageSource = "/static/images/towtruck.png";
            return (
                <div>
                < Card className = { this.state.editMode ? classes.card : classes.cardpink}  elevation={3} raised={true}>
                    < CardActionArea >
                        < CardContent >
                            <Grid container spacing={24}>
                                <Grid item xs={1} sm={1}>
                                <img  height={40} width={40} src={tempImageSource}  />
                                </Grid>
                                <Grid item xs={11} sm={11}>
                                      <div>
                                            < Typography  style={{display: 'inline-block' , color:'#054659'}}
                                                variant = "h6" >
                                                    Tow:  {this.props.info.vehiclevin +" - "+ this.props.info.vehicleplatenumber + " - " + this.props.info.vehiclestate}
                                            < /Typography>
                                        </div>
                                </Grid>

                                <Grid item xs={framelen} sm={framelen}>
                                        < Typography   style={{display: 'inline-block' , textDecoration: 'underline' , color:'#9d32a8'}}
                                            variant = "subtitle2"
                                        >

                                        Vehicle:
                                    < /Typography>
                                        <br/>
                                    < Typography  style={{display: 'inline-block',fontWeight:'fontWeightBold' , marginLeft: 15}}
                                        variant="body2"
                                        >
                                        {this.props.info.vehiclevin } <br/>
                                        {this.props.info.vehicleplatenumber + " - " + this.props.info.vehiclestate} <br/>
                                        {this.props.info.vehiclemake + " - " + this.props.info.vehiclemodel  +" - " + this.props.info.vehicleyear}

                                        < /Typography>
                                </Grid>


                            <Grid item xs={2} sm={2}>
                                    < Typography  style={{display: 'inline-block', textDecoration: 'underline', color:'#9d32a8'}}
                                variant = "subtitle2"
                                 >
                                    Location:
                            < /Typography>
                                    <br/>
                                < Typography  style={{display: 'inline-block' , marginLeft: 15}}
                                variant = "body2"
                                 >
                                    {this.props.info.locationaddress1 + " - " + this.props.info.locationaddress2 } <br/>
                                    {this.props.info.locationcity + ", " + this.props.info.locationstate + " " + this.props.info.locationzipcode } <br/>
                                    {this.props.info.locationauthorizedpeople}
                                < /Typography>
                            </Grid>

                            <Grid item xs={2} sm={2}>
                                    < Typography  style={{display: 'inline-block', textDecoration: 'underline',  color:'#9d32a8'}}
                                        variant = "subtitle2" >
                                    Police:
                                    < /Typography>
                                    <br/>
                                < Typography  style={{display: 'inline-block' , marginLeft: 15}}
                                    variant = "body2" >
                                    {this.props.info.policedepartmentname}<br/>  {this.props.info.policechiefname}<br/>
                                        {this.props.info.policeaddress1} {this.props.info.policeaddress2} <br/>
                                        {this.props.info.policecity+", "+ this.props.info.policestate + " "+ this.props.info.policezipcode}<br/>
                                        {"Fax: " + this.props.info.policefax} <br/>
                                        {"Phone: " +this.props.info.policephone} <br/>
                                        {"Email: " + this.props.info.policeemail}


                                < /Typography>
                            </Grid>


                                    <Grid item xs={2} sm={2}>
                                        < Typography  style={{display: 'inline-block', textDecoration: 'underline'  , color:'#9d32a8'}}
                                            variant = "subtitle2" >
                                            Storage Lot:
                                        < /Typography>
                                        <br/>
                                        < Typography  style={{display: 'inline-block' , marginLeft: 15}}
                                        variant = "body2" >
                                            {this.props.info.storagelotname} <br/> {this.props.info.storagelotaddress1}  <br/>
                                            {this.props.info.storagelotcity+", "+ this.props.info.storagelotstate+ " "+ this.props.info.storagelotzipcode}

                                        < /Typography>
                                    </Grid>


                            <Grid item xs={2} sm={2}>
                                < Typography  style={{display: 'inline-block', textDecoration: 'underline' , color:'#9d32a8'}}
                                        variant = "subtitle2" >
                                Reason:
                                < /Typography>
                                        <br/>
                                 < Typography  style={{display: 'inline-block', marginLeft: 15}}
                                    variant = "body2" >
                                {this.props.info.reasoncause}
                                < /Typography>
                            </Grid>
                            <Grid item xs={2} sm={2}>
                                < Typography  style={{display: 'inline-block', textDecoration: 'underline'  , color:'#9d32a8'}}
                                    variant = "subtitle2" >
                                Note:
                                < /Typography>
                            <br/>
                            < Typography  style={{display: 'inline-block', marginLeft: 15}}
                            variant = "body2" >
                                {this.props.info.reasonnote}
                                < /Typography>
                                </Grid>

                    </Grid>
                        < /CardContent>
                < /CardActionArea>
            < CardActions >
                    <Tooltip title="Edit" aria-label="Edit">
                    <IconButton  color="primary" aria-label="edit" className={classes.margin}>
                    <EditIcon fontSize="large" onClick={() =>this.editImageClick(this.props.info)}/>
                    </IconButton>
                    </Tooltip>

                    <Tooltip title="Email Status" aria-label="Email Status">

                        < Typography  className={classes.textLeftMargin} style={{display: 'inline-block'}}
                            variant = "button" >
                        Emails:None
                        < /Typography>

                    </Tooltip>

                <Tooltip title="Fax Status" aria-label="Fax Status">
                    <div>
                            < Typography   className={classes.textLeftMargin} style={{display: 'inline-block'}}
                        variant = "button" >
                            Fax:
                        < /Typography>   <br/>
                        < Typography     style={{display: 'inline-block'}}
                        variant = "button" >
                            Fredi@yahoo.com
                    < /Typography>
                    </div>


                </Tooltip>

                <Tooltip title="Tow Status" aria-label="Tow Status">

                    < Typography   className={classes.textLeftMargin} style={{display: 'inline-block'}}
                variant = "button" >
                    Status: Complete
                < /Typography>

                </Tooltip>



            < /CardActions>
            < /Card>


                <Dialog
                open={this.state.open}
                onClose={this.handleClose}
                PaperComponent={this.PaperComponent}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                    >
                    <DialogTitle id="alert-dialog-title">{"Do you want to remove a user?"}</DialogTitle>
                    <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                    This User with the first name {this.props.info.firstName} and last name  {this.props.info.lastName} will be deleted from your profile.
                </DialogContentText>
                </DialogContent>
                <DialogActions>
                <Button onClick={this.handleClose} color="primary">
                    Cancel
                    </Button>
                    <Button onClick={this.handleDelete} color="primary" autoFocus>
                Delete
                </Button>
                </DialogActions>
                </Dialog>

                </div>
        )
            ;
        }//end of render
}//End of class

CardFullTowJobInformation.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CardFullTowJobInformation);